<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
  <h2>{{service.name}}</h2>
  @if (portalDescription) {
    <p class="text-muted" style="max-width: 70ch; white-space: pre-line;">{{portalDescription}}</p>
  }

  @if (service.fileFormats) {
    <div>
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
        <ng-select
          style="flex: 1; min-width: 0;"
          [items]="service.fileFormats"
          bindLabel="name"
          bindValue="id"
          [clearable]="false"
          [searchable]="false"
          [disabled]="data==null || startLoading"
          [ngModel]="currentFileFormatId"
          (ngModelChange)="onChange($event)">
          <ng-template ng-label-tmp let-item="item">
            @if (data==null || startLoading) {
              <span class="format-spinner"></span>
            }
            {{item?.name}}
          </ng-template>
        </ng-select>
        <button class="btn btn-sm btn-outline-success" style="flex-shrink: 0;" [disabled]="!data?.total || downloading" (click)="downloadExcel()">
          @if (downloading) {
            <span class="spinner-border spinner-border-sm me-1" style="border-color: rgba(0,128,0,0.3); border-top-color: var(--success);"></span>
          }
          @if (!downloading) {
            <lucide-icon name="file-spreadsheet" size="16"></lucide-icon>
            }<span class="d-none d-md-inline">&nbsp;{{'CSV.EXCEL_DOWNLOAD' | translate}}</span><span class="d-md-none">&nbsp;XLS</span>
          </button>
        </div>
        <br/>
        @if (splitByYear && (years.length || hasNoYear)) {
          <ul ngbNav class="nav-tabs mb-2"
            [activeId]="activeYear" (activeIdChange)="selectYear($event)">
            @for (y of years; track y) {
              <li [ngbNavItem]="y" [disabled]="yearLoading">
                <a ngbNavLink>
                  @if (yearLoading && activeYear === y) {
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    }{{ y }}
                  </a>
                </li>
              }
              @if (hasNoYear) {
                <li [ngbNavItem]="'__none__'" [disabled]="yearLoading">
                  <a ngbNavLink>
                    @if (yearLoading && activeYear === '__none__') {
                      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                      }{{ 'CSV.NO_YEAR' | translate }}
                    </a>
                  </li>
                }
              </ul>
            }
            @if (data != null && !startLoading) {
              <div style="width: 100%;">
                <ntr-datatable [metaInfo]="metaInfo" [data]="data" [disableHeader]="false" [actionButtons]="false" (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="['','Name','Code','Type']"></ntr-datatable>
              </div>
            }
          </div>
        }

        @if (!service.fileFormats) {
          <div>
            {{'CSV.NO_FORMAT' | translate}} {{service.name}}
          </div>
        }
      </div>
      <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
        <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.DOWNLOADING' | translate}}...</p>
      </ngx-spinner>
